<div class="container">
  <h5 style="color: #428bca!important;">Отправка объектов в рекламу</h5>
  <h6>
    Адрес:
    <ng-container *ngIf="data.sale.location.street.title.length >0 ">
      {{data.sale.location.street.title}},
    </ng-container>
    {{data.sale.location.house}}
    <ng-container *ngIf="data.sale.location.housing !== '0' && data.sale.location.housing !== ''">
      / {{data.sale.location.housing}}
    </ng-container>
  </h6>
  <!--  <div style="margin-bottom: 20px">
      Чат-бот в Telegram для получения ссылок на рекламу: <a href="http://t.me/mlsbelan_bot" target="_blank">http://t.me/mlsbelan_bot</a>
    </div>-->


  <table class="table table-bordered">
    <tr *ngFor="let site of data.sites">
      <td>
        <div class="checkbox">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="{{ site.id}}"
                   [checked]="data.sale.arraySites[site.id]"
                   (change)="data.sale.arraySites[site.id] = !data.sale.arraySites[site.id]">
            <label class="form-check-label">
              {{ site.title}}
            </label>
          </div>
        </div>
      </td>
      <td style="min-width: 200px"></td>
    </tr>

  </table>

  <mat-dialog-actions>
    <button style="background: #cee0ec" mat-button (click)="onNoClick()">Отмена</button>
    <button style="background: #cee0ec" mat-button [mat-dialog-close]="data.sale" cdkFocusInitial>Сохранить</button>
  </mat-dialog-actions>

</div>
